export const themeColor = "#6100d4";
export const darkThemeColor = "#162349";
export const hoverEffect = `rgba(0, 0, 0, 0.56) 0px 22px 70px 4px`;
export const cardShadow = `rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px`;
